export const GET_SETTINGS_FAILURE = 'GET_SETTINGS_FAILURE';

export const getSettingsFailure = ({ error, request }) => ({
    type: GET_SETTINGS_FAILURE,
    payload: error,
    error: true,
    meta: {
        request
    }
});